import { h } from 'preact'
import { EsiInclude } from '../../esi-include/esi-include'
import styles from './map.module.css'

export const Map = ({ id }) => <EsiInclude className={styles.map} id={id} />
